import React from 'react';
import { IconButton } from "../../../../ui/CTA";
import { TrashCanIcon } from "../../../../ui/Icon";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import HeadingSmall from "../../../../ui/Typography/titles/HeadingSmall";
import styles from './AppliedGiftCards.module.scss';
const AppliedGiftCards = ({ appliedGiftCards, labels, removeGiftCard, }) => {
    return (React.createElement(React.Fragment, null, appliedGiftCards.map((giftcard) => {
        return (React.createElement("section", { className: styles.appliedGiftCard },
            React.createElement(HeadingSmall, { className: styles.heading },
                `${labels.heading} - ${giftcard.cardNumber.substring(0, 4)}... ${labels.applied}`,
                React.createElement(IconButton, { onClick: () => removeGiftCard(giftcard.cardNumber), className: styles.trashCanIcon, iconElement: React.createElement(TrashCanIcon, { size: "small" }) }, labels.removeGiftCard)),
            React.createElement(MetaText, { Tag: "p", className: styles.valueDeducted }, `${giftcard.deductedAmount.formattedValue} - ${labels.valueDeducted}`),
            React.createElement(MetaText, { Tag: "p", className: styles.valueRemaining }, `${giftcard.remainAmount.formattedValue} - ${labels.valueRemaining}`)));
    })));
};
export default AppliedGiftCards;
//# sourceMappingURL=AppliedGiftCards.js.map